import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-edit-order-warning-dialog',
    templateUrl: './edit-order-warning-dialog.component.html',
    styleUrls: ['./edit-order-warning-dialog.component.scss']
  })

  export class EditOrderWarningDialogComponent implements OnInit {

    @Input() openDialog: boolean;
    @Input() selectedOrder: any;
    @Output() confirmContinue = new EventEmitter();
    @Output() closeEvent = new EventEmitter();


    ngOnInit(): void {
    }

    continueClicked() {
        this.confirmContinue.emit();
    }

    closeClicked() {
        this.closeEvent.emit();
    }

}
